import { DateTime } from 'luxon';

const millis = new Date().getTimezoneOffset() * 60 * 1000;

const capitalizeFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);

export const dateNumberToString = (
  timestamp: number,
  variant: 'small' | 'medium' | 'large'
) => {
  const date = DateTime.fromMillis(timestamp + millis);

  date.setLocale('es-PE');

  const dayShortName = date.toLocaleString({ weekday: 'short' });
  const dayLongName = date.toLocaleString({ weekday: 'long' });
  const dayTwoDigit = date.toLocaleString({ day: '2-digit' });
  const monthLongName = date.toLocaleString({ month: 'long' });
  const monthShortName = date.toLocaleString({ month: 'short' });
  const yearNumeric = date.toLocaleString({ year: 'numeric' });

  const small = `${dayTwoDigit} ${monthShortName} ${yearNumeric}`;
  // const small1 = `${dayShortName}, ${dayTwoDigit} ${monthShortName} ${yearNumeric}`;
  const medium = `${dayShortName}, ${dayTwoDigit} de ${monthShortName} ${yearNumeric}`;
  const large = `${dayLongName}, ${dayTwoDigit} de ${monthLongName} de ${yearNumeric}`;

  let result = '';

  if (variant === 'small') result = small;
  if (variant === 'medium') result = medium;
  if (variant === 'large') result = large;
  // if (variant === 'small1') result = small1;

  return capitalizeFirstLetter(result);
};
